// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3877":"fe336940f98fdfab","5673":"8c84e08b49309ac5","6114":"b354f2dc2f49a79d","6272":"aa4472f7082b94cd","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};